import axios from "axios";
import API from "../../common/API";
import { API_URL } from "../../config/config";

/*** 
@purpose : Get submission data list
@Parameter : {}
**/
export const fetchSubmissionDataList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + API.GET_SUBMISSION_DATA_LIST + `?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        timestamp: timestamp,
        mode: "no-cors",
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get submission type list
@Parameter : {}
**/
export const fetchSubmissionTypeList = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        API.GET_SUBMISSION_TYPE_LIST +
        `?submission_data=${body.data}&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get org customer type list
@Parameter : {}
**/
export const fetchOrgCustTypeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL +
        `/getcustomertype?submission_data=organization_customer&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get person customer type list
@Parameter : {}
**/
export const fetchPerCustTypeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(
      API_URL + API.GET_PERSON_CUSTOMER_TYPE_LIST + `&timestamp=${timestamp}`,
      {
        headers: {
          "x-api-key": token,
          "Access-Control-Allow-Origin": "*",
          timestamp: timestamp,
          mode: "no-cors",
        },
      }
    )
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response.data.data;
      }
    });
};

/*** 
@purpose : Get submission type list
@Parameter : {}
**/
export const fetchCustomerTypeList = async () => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return await axios
    .get(API_URL + API.GET_CUSTOMER_TYPE + `?timestamp=${timestamp}`, {
      headers: {
        "x-api-key": token,
        "Access-Control-Allow-Origin": "*",
        timestamp: timestamp,
        mode: "no-cors",
      },
    })
    .then((response) => {
      if (response.data.success == true && response.data.data) {
        return response;
      }
    });
};

/*** 
@purpose : Customer request status inquiry
@Parameter : {body}
**/
export const customerRequestStatusInquiry = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  return fetch(API_URL + API.CUSTOMER_REQUEST_STATUS_INQUIRY, {
    method: "post",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Customer request Details
@Parameter : {body}
**/
export const customerRequestDetails = async (body) => {
  const token = sessionStorage.getItem("token");
  const wwid = sessionStorage.getItem("WWID");
  let timestamp = new Date().getTime();
  return fetch(API_URL + API.GET_CUSTOMER_REQUEST_DETAILS, {
    method: "post",
    headers: {
      "x-api-key": token,
      "Access-Control-Allow-Origin": "*",
      wwid: wwid,
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Resubmit DCR request
@Parameter : {body}
**/
export const resubmitChangeRequest = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.RESUBMIT_REQUEST, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Edit DCR request
@Parameter : {body}
**/
export const editChangeRequest = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.EDIT_REQUEST, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Withdraw org DCR request
@Parameter : {body}
**/
export const withdrawOrgRequest = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.WITHDRAW_ORG_REQUEST, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Withdraw person DCR request
@Parameter : {body}
**/
export const withdrawPersonRequest = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.WITHDRAW_PERSON_REQUEST, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};

/*** 
@purpose : Withdraw affiliation DCR request
@Parameter : {body}
**/
export const withdrawAffiliationRequest = async (body) => {
  const token = sessionStorage.getItem("token");
  let timestamp = new Date().getTime();
  const wwid = sessionStorage.getItem("WWID");
  return fetch(API_URL + API.WITHDRAW_AFFILIATION_REQUEST, {
    method: "post",
    headers: {
      "x-api-key": token,
      wwid: wwid,
      "Access-Control-Allow-Origin": "*",
      timestamp: timestamp,
      mode: "no-cors",
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      return data;
    });
};
